var React = require('react');

function Car (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.273 3a1 1 0 0 0-.879.521l-2.279 4.18-1.408-1.408L.293 7.707l1.824 1.824A1 1 0 0 0 2 10v8 2a1 1 0 0 0 1 1h2l-.006-2h14.012L19 21h2c.55 0 1-.45 1-1v-2-8a1 1 0 0 0-.105-.447l-.012-.021 1.824-1.824-1.414-1.414-1.352 1.352-2.047-4.092A1 1 0 0 0 18 3H6.273zm.594 2h10.516l2 4H14.5h-.922H9.5 4.686l2.182-4zM9.5 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 1 0 0 3zm5 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 1 0 0 3zM4 11h9.578H20v6H4v-6zm3 2a1 1 0 1 0 0 2 1 1 0 1 0 0-2zm10 0a1 1 0 1 0 0 2 1 1 0 1 0 0-2z"}));
}

Car.defaultProps = {"viewBox":"0 0 24 24","xmlnsV":"https://vecta.io/nano"};

module.exports = Car;

Car.default = Car;
